import React, { useEffect, useState } from 'react';
import styles from './Game.module.css';
import GameTable from '@/src/components/GameTable/GameTable';
import GameActionsRow from '@/src/components/GameActionsRow/GameActionsRow';
import UtilityRow from '@/src/components/UtilityRow/UtilityRow';
// import GameTableLoader from '@/src/components/GameTableLoader/GameTableLoader';
import { GameTableLoader } from '@themed-components';
import { useSwiper, useSwiperSlide } from 'swiper/react';
import useActiveGame from '@/src/hooks/data/useActiveGame';
import useActiveGames from '@/src/hooks/data/useActiveGames';
import BuyInDrawer from '@/src/components/BuyInDrawer/BuyInDrawer';
import GameTableIdentity from '@/src/components/GameTableIdentity/GameTableIdentity';
import GameSwipeSettings from '@/src/components/GameSwipeSettings/GameSwipeSettings';
import { useIsTourneyGame } from '@/src/hooks/data/useGameTable';
import TourneyGameTableUI from '@/src/components/TourneyGameTableUI/TourneyGameTableUI';

const Game = ({ index, tempTableId }) => {
    // Swiper Hooks and Logic
    const swiper = useSwiper();
    const swiperSlide = useSwiperSlide();
    const activeGame = useActiveGame();
    const activeGames = useActiveGames();
    const isTourneyGame = useIsTourneyGame(tempTableId);

    // State for snap scroll functionality
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);

    useEffect(() => {
        if (swiperSlide.isActive && tempTableId !== activeGame) {
            let indexOfGame = activeGames.indexOf(activeGame);
            swiper.slideToLoop(indexOfGame);
        }
    }, [activeGame, swiperSlide.isActive]);

    const handleToggleSettings = () => {
        setIsSettingsOpen(!isSettingsOpen);
    };

    return (
        <div className={styles.gameContainer}>
            <div className={styles.gameTableSlide}>
                {/* Game Table Loader */}
                <GameTableLoader tempTableId={tempTableId} />
                {/* Game Info Section */}
                <GameTableIdentity tempTableId={tempTableId} />
                <div className={styles.gameTableTopRow}>
                    {/* Empty Placeholder. Top Row Content will be available in GameTablesLayout as it is common for all tables. */}
                </div>
                <div className={styles.perspectiveGameTableSection}>
                    <GameTable tempTableId={tempTableId} />
                </div>
                <div className={styles.gameTableBottomSection}>
                    <UtilityRow tempTableId={tempTableId} />
                    <GameActionsRow tempTableId={tempTableId} />
                </div>
                {/* Miscellaneous Components / Overlays like BuyIn, TopUp, RebuyIn, Insufficient Funds etc. */}
                <BuyInDrawer
                    tempTableId={tempTableId}
                />
                {
                    isTourneyGame && (
                        <TourneyGameTableUI tempTableId={tempTableId} />
                    )
                }
            </div>
            <GameSwipeSettings
                tempTableId={tempTableId}
                isOpen={isSettingsOpen}
                onToggle={handleToggleSettings}
            />
        </div>
    );
}

export default Game;
